<div class="container">
  @for (option of options; track option) {
    <div class="option" [class.selected]="option.value === localFormControl.value" (click)="selectOption(option.value)">
      <fa-icon icon="check" size="sm" class="selected-icon" />
      <span>{{ option.label }}</span>
    </div>
  }
</div>
